import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Spinner,
  Button
} from "reactstrap";
import classNames from "classnames";
import _ from "lodash";
import * as Icon from "react-feather";

import DataTable from "../../components/DataTable";
import useMergeState from '../../hooks/mergeState';
import { useAuth } from "../../hooks/useAuth";

import { getProductsAction } from "../../redux/reducers/subscriptionReducer";
import { startActionWithPromise } from "../../helpers/saga-promise-helpers";
import "./index.scss";
import { getTableColumns } from "./TableColumns";
import ProductModal from "./ProductModal";

const ServiceProducts = ({user}) => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    modalConfirm: false,
    modalProduct: false,
    action: '',
    message: '',
  });

  const defaultFilters = {
    reload: false,
  };

  const [filters, setFilters] = useMergeState(defaultFilters);

  const [waiting, setWaiting] = useState(false);
  
  const auth = useAuth();
  const isAuthorized = auth.roles &&
    (auth.roles.indexOf('SYSTEM_ADMINS') !== -1 ||
    auth.roles.indexOf('SYSTEM_OPERATORS') !== -1);
  const fetching = false;
  const [serviceProducts, setServiceProducts] = useState([]);
  const [serviceAddons, setServiceAddons] = useState([]);

  const isBoAdmin = useSelector(state => state.bouser.isBoAdmin);

  const handleUpdateIcon = (row, event) => {
    setState({
      ...state,
      modalProduct: true,
      row
    });
  }

  const tableColumns = getTableColumns(isBoAdmin, handleUpdateIcon);

  const toggleModal = (modal) => {
    if (state[modal]) setState({ ...state, [modal]: !state[modal] });
    else setState({ ...state, [modal]: !state[modal], row: null });
  };

  const refreshDatatable = () => {
    setFilters({ ...filters, reload: true });
  };
  
  const fetchProducts = () => {
    (async () => {
      try {
        // setWaiting(true);
        const resp = await startActionWithPromise(
          getProductsAction,
          {successCallback: () => {}, failedCallback: () => {}},
          dispatch
        );
        
        if (resp) {
          setServiceProducts(resp);
          setServiceAddons(resp.filter(prod => prod.type === 'ADD_ON'));
        } else {
          setServiceProducts([]);
          setServiceAddons([]);
        }
      } catch {}
      setWaiting(false);
    })();
  };

  useEffect(() => {
    if (filters.reload) {
      fetchProducts();
      setFilters({ ...filters, reload: false });
    }
  }, [filters.reload]);

  useEffect(() => {
    fetchProducts();
  }, []);

  ////////// Table's action handlers ///////////
  const handleCreateButton = () => {
    setState({
      ...state,
      modalProduct: true,
      row: {
        id: null,
        active: true,
        addons: [],
      }
    });
  };
  
  ////////////////////

  return (
    <Container fluid className="p-0">
      <h1 className="page-title">Service Products</h1>
      <Row>
        <Col lg="12" className="d-flex">
        <>
          <Card className={classNames('w-100 mb-0 datatable-wrap')}>
            <CardHeader className="">
              <div className="d-flex align-items-right float-right">
                <Button
                  className="ml-2"
                  size=""
                  disabled={!isBoAdmin || fetching}
                  onClick={(e) => handleCreateButton(e)}
                  style={{minWidth: '86px'}}
                  color="success"
                >
                  <Icon.Plus style={{ width: '15px', height: '15px', marginTop: '-2px' }} /> Create
                </Button>
              </div>
            </CardHeader>
            <CardBody className="pt-0 data-list">
              <div className="d-flex align-items-center ml-3">
                &nbsp;
              </div>
              { waiting ? (
                <div className="loading-content text-center p-4 border-top">
                  <Spinner size="sm" />
                </div>
              ) : (
                <>
                  <DataTable
                    keyField="id"
                    data={serviceProducts}
                    columns={tableColumns}
                    hideSelectColumn={true}
                  />
                </>
              )}
            </CardBody>
          </Card>
          {state.modalProduct && (
            <ProductModal
              modal={state.modalProduct}
              addons={state.row?.type === 'BASE' ? serviceAddons : [] }
              toggle={toggleModal}
              row={state.row}              
              refreshData={refreshDatatable}
              updateMode={state.row.id !== null}
              isBoAdmin={isBoAdmin}
            />
          )}
        </>
        </Col>
      </Row>
    </Container>
  );
};

export default ServiceProducts;
